import { createSelector } from 'reselect'

import { RootState } from '@/store'
import { getSpaces, getUsers } from '@/store/selectors'
import { mapToUser } from '@/utilities/UserUtilities'

export const getSpaceAdmins = (state: RootState) => {
  const currentSpaceMembers = state.organizationSpaceEditPage.users
  if (currentSpaceMembers) {
    const users = getUsers(state)
    return currentSpaceMembers.map(user => {
      return mapToUser(users.byId[user])
    })
  }
}

export const getSearchedUsersNotAlreadyAdmins = (state: RootState) => {
  if (state.organizationSpaceEditPage && state.organizationSpaceEditPage.searchedUsers) {
    const users = getUsers(state)
    const filteredSearchedUsers = state.organizationSpaceEditPage.searchedUsers.filter(
      user =>
        !getSpaceAdmins(state)
          ?.map(u => u.id)
          .includes(user)
    )
    return filteredSearchedUsers.map(user => {
      return mapToUser(users.byId[user])
    })
  } else {
    return []
  }
}

export const makeGetSpaceById = () => {
  return createSelector([getSpaces, (_, spaceId) => spaceId], (spaces, spaceId) =>
    spaces.find(space => space.id === spaceId)
  )
}
